export default __webpack_public_path__ + "static/329-0c98691d714449e30e25d32213398a83.gif";